import type { TSiteSectionsTreeData } from "@/app/tools/new-section-management/site-sections-tree/site-sections-tree.types";
import type { ISelectSectionSimpleTreeNodeTag, IVirtualizedTreeNode } from "@voltalis/ui-kit/components";

import { isPendingSiteSectionPreviewNode } from "@/app/tools/new-section-management/site-sections-tree/site-sections-tree-pending-preview";

interface IBuildSelectSectionParentDialogNodeTagsOptions {
  node: IVirtualizedTreeNode<TSiteSectionsTreeData>;
  maybeInitialSectionParent?: TSiteSectionsTreeData;
  labels: {
    parent: string;
  };
}

export function buildSelectSectionParentDialogNodeTags({
  node,
  maybeInitialSectionParent,
  labels,
}: IBuildSelectSectionParentDialogNodeTagsOptions): ISelectSectionSimpleTreeNodeTag[] {
  if (isPendingSiteSectionPreviewNode(node)) {
    return [{ label: "", variant: "destination" }];
  }

  if (maybeInitialSectionParent !== undefined && node.data?.id === maybeInitialSectionParent?.id) {
    return [{ label: labels.parent, variant: "parent" }];
  }

  return [];
}
